export default __webpack_public_path__ + "static/media/G0810-RAR.1710502860000.316b3c65.jpg";